import React from "react";
import {
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const GoogleBarChart = ({ data }) => {
  const labels = (data || []).map((item) => item.year_label);
  const chartData = {
    labels,
    datasets: [
      {
        label: "Projects",
        data: (data || []).map((item) => parseInt(item.projects_created, 10) || 0),
        backgroundColor: "#6996b5",
      },
      {
        label: "Delivered",
        data: (data || []).map((item) => parseInt(item.ships_delivered, 10) || 0),
        backgroundColor: "#333333",
      },
      {
        label: "Ship Trial",
        data: (data || []).map((item) => parseInt(item.trials_completed, 10) || 0),
        backgroundColor: "#2b5a7e",
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      title: {
        display: true,
        text: "NEW-BUILDING SHIP STATISTICS",
      },
      legend: {
        position: "top",
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
      },
      y: {
        beginAtZero: true,
        ticks: {
          precision: 0,
        },
      },
    },
  };

  return (
    <div className="card">
      <div className="card-body">
        <div style={{ height: "400px" }}>
          <Bar data={chartData} options={options} />
        </div>
      </div>
    </div>
  );
};

export default GoogleBarChart;
